// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-boundary-container {
  padding: 2rem;
  text-align: center;
  margin-top: 10%;
  color: #fff;
}

.error-boundary-container h2 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.error-boundary-container p {
  color: #94a3b8;
  font-size: 0.95rem;
}

.error-boundary-reload-btn {
  padding: 10px 20px;
  margin-top: 20px;
  cursor: pointer;
  background: #3eb8cc;
  color: #050c0f;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  transition: opacity 0.2s ease;
}

.error-boundary-reload-btn:hover {
  opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/styles/error-boundary.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd","sourcesContent":[".error-boundary-container {\n  padding: 2rem;\n  text-align: center;\n  margin-top: 10%;\n  color: #fff;\n}\n\n.error-boundary-container h2 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.error-boundary-container p {\n  color: #94a3b8;\n  font-size: 0.95rem;\n}\n\n.error-boundary-reload-btn {\n  padding: 10px 20px;\n  margin-top: 20px;\n  cursor: pointer;\n  background: #3eb8cc;\n  color: #050c0f;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  transition: opacity 0.2s ease;\n}\n\n.error-boundary-reload-btn:hover {\n  opacity: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
